import { isValidChainId, type ValidChainId, } from "@bracket/types";
import { getChainId, } from "wagmi/actions";


export const getValidChainId = ( config, ): ValidChainId => {
  const chainId = getChainId(config);
  if(isValidChainId(chainId)) {
    return chainId;
  }
  throw new Error("invalid chain id");
}